import * as React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import { GoogleTagManager } from '../GoogleTagManager';
import { PromotionImpressionViewModel } from './PromotionImpressionViewModel.csharp';

interface WithPromotionImpressionState {
    wasVisible: boolean;
}

export function withPromotionImpression<TProps extends { model: TModel }, TModel extends { promotionImpression: PromotionImpressionViewModel }>(
    WrappedComponent: React.FC<TProps>
) {
    return class extends React.Component<TProps, WithPromotionImpressionState> {
        constructor(props: TProps) {
            super(props);

            this.state = {
                wasVisible: false
            };
        }

        onChange = (isVisible: boolean) => {
            if (isVisible && !this.state.wasVisible) {
                this.setState({ wasVisible: true });
                this.props.model.promotionImpression && GoogleTagManager.promotionImpression(this.props.model.promotionImpression);
            }
        };

        captureLinkClick = (e: React.MouseEvent) => {
            if (this.props.model.promotionImpression !== null) {
                const anchors = e.currentTarget.getElementsByTagName('a');

                for (let i = 0; i < anchors.length; i++) {
                    if (anchors[i].href.includes(this.props.model.promotionImpression.link)) {
                        GoogleTagManager.promotionClick(e, this.props.model.promotionImpression, anchors[i].href);
                        e.preventDefault();
                    }
                    e.preventDefault();
                }
            }
        };

        render() {
            return this.props.model.promotionImpression === null ? (
                <WrappedComponent {...this.props} />
            ) : (
                <VisibilitySensor onChange={this.onChange}>
                    <div style={{ width: '100%', height: '100%' }} onClick={(e) => this.captureLinkClick(e)}>
                        <WrappedComponent {...this.props} />
                    </div>
                </VisibilitySensor>
            );
        }
    };
}
